<template>
  <div class="comment_container">
    <div v-for="(item, index) in comments" @click="disabledComment('update_cm', item.cid)" :key="index"
      class="comment_item">
      <div>
        <div class="avatar">{{ item.utime.split(' ')[0] + ' ' + allSelect.TEXTUSERS[item.username] }} 添加了评论：
        </div>
        <el-button v-if="item.username === username" size="mini" type="warning"
          @click.stop="onCommentSubmit('delete_cm', item.cid)">删 除</el-button>
        <el-button v-if="item.username === username && item.disabled" size="mini" type="warning"
          @click="onCommentSubmit('update_cm', item.cid)">修 改</el-button>
      </div>
      <EditorComment :cid="String(item.cid)" :config="allSelect" :content="item.comment"
        @commentData="changeCreateCmContent" :disabled="item.disabled && item.username === username" />
    </div>
    <div class="comment_new" v-if="allSelect.TEXTUSERS[username] || username === 'admin'" @click="disabledComment('create_cm')">
      <EditorComment :config="allSelect" :content="create_cm" @commentData="changeCreateCmContent" />
      <div style="margin-top:10px;" v-show="show_create_cm">
        <el-button type="primary" size="mini" @click="onCommentSubmit('create_cm')">添 加</el-button>
        <el-button size="mini" @click="onCommentCancel('create_cm')">取 消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getDevOpsSpaceProducerCommentApi,
  postDevOpsSpaceProducerCreateCommentApi,
  postDevOpsSpaceProducerDeleteCommentApi,
  postDevOpsSpaceProducerUpdateCommentApi
} from "@/server/tops/devOps";
import { EditorComment } from "@/components/index.js";
import { mapState } from "vuex";
export default {
  components: { EditorComment },
  props: {
    pid: {
      type: [String, Number],
      default: function () {
        return ''
      }
    },
    tid: {
      type: [String, Number],
      default: function () {
        return ''
      }
    },
    type: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  data() {
    return {
      comments: [],
      create_cm: "",
      show_create_cm: false,
      username: '',
    };
  },
  async created() {
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : 'admin';
    this.username = username;
    await this.queryCommentInfo()
  },
  computed: {
    ...mapState(
      {
        allSelect: (state) => state.devOps.ALLSELECT,
      }
    )
  },
  methods: {
    // 获取评论信息
    async queryCommentInfo() {
      const ret = await getDevOpsSpaceProducerCommentApi({ pid: this.pid, tid: this.tid, type: this.type })
      this.comments = ret.data.map((item) => {
        item.disabled = false;
        return item;
      });
      console.log(this.comments)
    },
    // 写入评论信息
    changeCreateCmContent({ text, cid, show }) {
      if (!cid) {
        this['create_cm'] = text;
        this.show_create_cm = show;
      } else {
        this.comments = this.comments.map(item => {
          if (item.cid == cid) {
            item.comment = text;
          }
          return item;
        })
      }
    },
    // 提交评论信息
    async onCommentSubmit(stype, cid) {
      const { pid = '', tid = '', type = '' } = this;
      if (stype === 'create_cm') {
        await postDevOpsSpaceProducerCreateCommentApi({ pid, tid, comment: this[stype], type })
        await this.queryCommentInfo()
        this[stype] = '';
        setTimeout(() => {
          this['show_' + stype] = false;
        })
        return;
      }
      if (stype === 'delete_cm') {
        await postDevOpsSpaceProducerDeleteCommentApi({ cid, pid, tid, type })
        await this.queryCommentInfo()
        return;
      }
      if (stype === 'update_cm') {
        const item = this.comments.filter(item => item.cid === cid)
        await postDevOpsSpaceProducerUpdateCommentApi({ cid, pid, tid, comment: item[0].comment, type })
        await this.queryCommentInfo()
        return;
      }
    },
    // 取消评论信息
    onCommentCancel(type) {
      this[type] = '';
      setTimeout(() => {
        this['show_' + type] = false;
      })
    },
    disabledComment(type, cid) {
      this.comments = this.comments.map((item) => {
        item.disabled = item.cid === cid;
        return item;
      });
      this.show_create_cm = (type === 'create_cm');
    },
  },
};
</script>
<style lang="scss" scoped>
.comment_container {
  .avatar {
    height: 30px;
    line-height: 30px;
    text-align: left;
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
<style lang="scss">
.comment_new {
  .editorComment_warp {
    .editorComment {
      .ql-editor {
        min-height: 60px !important;
      }
    }
  }
}

.devOps-producerModel {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }

  }

  .el-button--mini {
    padding: 6px 10px;
    font-size: 12px;
  }



  .el-form-item__content .el-button {
    position: relative;
    letter-spacing: 2px !important;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .el-button {
    font-weight: bold;
  }

  .share {
    position: absolute;
    top: 20px;
    right: 46px;
    cursor: pointer;
    color: #409eff;
  }
}
</style>
